import ChevronRight from '@assets/icons/chevron-right.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import { displayCurrencyPlaceholder, formatCurrency } from '@/utils/money';
import { MenuItemListOption } from '@/contexts/menu-info-context';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';
import { useTheme } from '@/contexts/theme-context';
import { useVariantPackInfoContext } from '@/contexts/variant-pack-info-context';

interface Props {
  onSelect: (menuItemUUID: string) => void;
  option: MenuItemListOption;
}

export const MenuItemListItem: React.FC<Props> = ({ onSelect, option }) => {
  const { currencyCode } = useVariantPackInfoContext();
  const theme = useTheme();

  return (
    <TouchableOpacity
      onPress={() => onSelect(option.metadata!.uuid)}
      style={styles.base}
    >
      <View style={styles.row}>
        <Text style={TYPOGRAPHY.pSemiBold}>{option.title}</Text>
        <Text style={TYPOGRAPHY.pSemiBold}>
          {typeof option.metadata!.platePriceInMicros === 'number'
            ? formatCurrency(option.metadata!.platePriceInMicros)
            : displayCurrencyPlaceholder(currencyCode)}
        </Text>
      </View>
      <View style={[styles.row, styles.priceRow]}>
        <View style={styles.priceColumn}>
          <Text style={TYPOGRAPHY.p}>
            {i18n.t('menu_item.total_plate_cost')}
          </Text>
          <Text style={TYPOGRAPHY.pSemiBold}>
            {typeof option.metadata!.plateCostInMicros === 'number'
              ? formatCurrency(option.metadata!.plateCostInMicros)
              : displayCurrencyPlaceholder(currencyCode)}
          </Text>
        </View>
        <View style={styles.priceColumn}>
          <Text style={TYPOGRAPHY.p}>
            {i18n.t('menu_item.profit_per_plate')}
          </Text>
          <Text style={TYPOGRAPHY.pSemiBold}>
            {typeof option.metadata!.plateCostInMicros === 'number' &&
            typeof option.metadata!.platePriceInMicros === 'number'
              ? formatCurrency(
                  option.metadata!.platePriceInMicros -
                    option.metadata!.plateCostInMicros,
                )
              : displayCurrencyPlaceholder(currencyCode)}
          </Text>
        </View>
        <ChevronRight fill={theme.colors.inactiveFill} height="12" />
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  base: {
    flex: 1,
  },
  priceColumn: {
    flexDirection: 'column',
    gap: 4,
  },
  priceRow: {
    marginTop: 16,
  },
  row: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});
